<template>
  <div>
    <p class="rich-title mb-7">
      <slot name="title"></slot>
    </p>
    <div>
      <app-editor :editable="false" :value="body" ref="editor" />
    </div>
  </div>
</template>
<script>
import Editor from "@/components/Utils/Editor.vue";
export default {
  components: {
    appEditor: Editor,
  },
  props: {
    body: {
      required: false,
      type: Object,
    },
  },
};
</script>
<style scoped>
.rich-title {
  font-size: 1.4rem;
}
</style>
